module.exports = __webpack_public_path__ + "static/media/ad-spring.53e2fa9e.png";